import { Grid, Tooltip, useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import styles from './../../../../assets/styles/componentStyles/templatemessages.module.scss'
import globalStyles from "../../../../assets/styles/global.module.scss";
import carouselStyles from './../../../../assets/styles/componentStyles/carouselCard.module.scss' 
import { secondaryColor } from '../../../../utils/colors';
import Slider from 'react-slick';
import TemplatePreviewGlobal from '../../../dashboard/channels/global/whatsapp/templates/previews/templatePreviewGlobal';
import { replacingTemplateMarkdownText } from '../../../../utils/constants';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import ReplyIcon from '@mui/icons-material/Reply';
import ListIcon from '@mui/icons-material/List';
import CallIcon from '@mui/icons-material/Call';
import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext';
import { renderTemplateDetailsGridInNode } from '../../../dashboard/flowBuilder/flowBuilderConstants';
import defaultWATemplateImg from "./../../../../assets/images/messageFormats/defaultWATemplateImage.png";
import { subButtonTypeIconMap } from '../../../dashboard/templatelibrary/constant';

interface WorkflowCarouselTemplatePreviewProps {
    actionData?: any,
    messageTemplateDetail?: any, 
    flagNodePreview?: boolean,
} 

const WorkflowCarouselTemplatePreview: React.FC<WorkflowCarouselTemplatePreviewProps> = (props) => {
    
    const { actionData, messageTemplateDetail, flagNodePreview } = props;

    const isScreenBelow1200 = useMediaQuery('(max-width : 1200px) and (min-width: 0px)');

    const [templateDetails, setTemplateDetails] = useState<any>(messageTemplateDetail);
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload
    
    useEffect(() => {
        let messageTemplate = currentActiveStaticWorkflow?.additional_data?.whatsapp_templates?.find((template) => Number(template.whatsapp_template_id) == Number(actionData.whatsapp_template.whatsapp_template_id))
        if (messageTemplate) {
            setTemplateDetails(messageTemplate)
        }
    }, [actionData])

    const onClickOfArrows = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, onClick: any) => {
        e.stopPropagation();
        if(typeof onClick == "function"){
            onClick();
        } 
    }

    function SampleNextArrow(props: any) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{
                    ...style,
                    display: "flex",
                    // background: '#F3F5F9',
                    background: secondaryColor,
                    padding: '3px 3px 2px',
                    borderRadius: '50%',
                    boxShadow: "0px 0px 3px rgba(0,0,0,0.25)"
                    // '--user-msg-bg-color': chatBotDetail?.chatbot_theme?.user_msg_bg_color || '#F3F5F9'
                }}
                onClick={(e) => onClickOfArrows(e, onClick)}
            />
        );
    }

    function SamplePrevArrow(props: any) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{
                    ...style,
                    display: "block",
                    padding: '3px 3px 1px',
                    borderRadius: '50%',
                    background: secondaryColor,
                    boxShadow: "0px 0px 3px rgba(0,0,0,0.25)"
                }}

                onClick={(e) => onClickOfArrows(e, onClick)}
            />
        );
    }

    function replaceWithSpanTags(bodyText: string, card: any) {
        let result = bodyText;
        if (actionData.action_send_dm_wa_carousel_template_variable_data.length > 0) {

            // Iterate through each variable mapping from action
            actionData.action_send_dm_wa_carousel_template_variable_data.forEach((variable: any) => {
                // @ts-ignore
                let variableKeyToReplace: any = card?.whatsapp_template_body?.whatsapp_template_body_variable_data.find((variable1: any) => Number(variable1.whatsapp_template_dynamic_variable_id) == Number(variable.whatsapp_template_dynamic_variable_id))?.whatsapp_template_dynamic_variable_key
                const variableKey = variableKeyToReplace
                let variableName = "";
                if (variableKey) {
                    if (variable?.chatbot_custom_variable_configuration) {
                        variableName = `{{${variable?.chatbot_custom_variable_configuration?.chatbot_custom_variable_name}}}`
                    } else if (variable?.fallback_value) {
                        variableName = variable.fallback_value
                    } else {
                        // @ts-ignore
                        variableName = templateDetails?.whatsapp_template_data[0]?.whatsapp_template_body?.whatsapp_template_body_variable_data[0]?.whatsapp_template_dynamic_variable_key
                    }
                    // Create a span tag with a style, you can modify the style as needed
                    const spanTag = `<span style="color: blue; font-weight: bold;">${variableName}</span>`;
                    // Replace the placeholder with the span tag
                    result = result.replace(variableKey, spanTag);
                }
            });
        }

        result = result.replace(/\*(.*?)\*/g, '<b>$1</b>');  // Bold
        result = result.replace(/\\n/g, '<br>');

        return result;
    }

    function replaceWithSpanTagsHeader(bodyText: string, card: any) { // For Carousel Global Header Variable && Card's Header Variable
        let result = bodyText;
        if (actionData.action_send_dm_wa_carousel_template_variable_data.length > 0) {

            // Iterate through each variable mapping from action
            actionData.action_send_dm_wa_carousel_template_variable_data.forEach((variable: any) => {
                // @ts-ignore
                let variableKeyToReplace: any = (card ? card?.whatsapp_template_header?.whatsapp_template_header_data[0]?.whatsapp_template_header_variable_data : templateDetails?.whtatsapp_carousel_header_variable_data)?.find((variable1: any) => Number(variable1.whatsapp_template_dynamic_variable_id) == Number(variable.whatsapp_template_dynamic_variable_id))?.whatsapp_template_dynamic_variable_key
                const variableKey = variableKeyToReplace
                let variableName = "";
                if (variableKey) {
                    if (variable?.chatbot_custom_variable_configuration) {
                        variableName = `{{${variable?.chatbot_custom_variable_configuration?.chatbot_custom_variable_name}}}`
                    } else if (variable?.fallback_value) {
                        variableName = variable.fallback_value
                    } else {
                        // @ts-ignore
                        variableName = variableKeyToReplace
                    }
                    // Create a span tag with a style, you can modify the style as needed
                    const spanTag = `<span style="color: blue; font-weight: bold;">${variableName}</span>`;
                    // Replace the placeholder with the span tag
                    result = result.replace(variableKey, spanTag);
                }
            });
        }

        result = result.replace(/\*(.*?)\*/g, '<b>$1</b>');  // Bold
        result = result.replace(/\\n/g, '<br>');

        return result;
    } 

    const messageText = (type: string, card?: any) => {
        let template: string = "";
        switch(type.toLowerCase()){
            case 'header': 
                return replaceWithSpanTagsHeader(templateDetails?.whtatsapp_carousel_header || "-", card);
            case 'body': 
                return replaceWithSpanTags(card?.whatsapp_template_body?.whatsapp_template_body_value || "-", card);
            case 'footer':
                template = card?.whatsapp_template_footer?.whatsapp_template_footer_value || "-";
                break;
            default:
                return "";
        }
        return replacingTemplateMarkdownText(template);
    }

    const getHeaderImage = (card: any) => {
        if (templateDetails) {
            // @ts-ignore
            let actionVarConfig = actionData?.action_send_dm_wa_carousel_template_variable_data?.find((variable: any) => Number(variable?.whatsapp_template_dynamic_variable_id) == Number(card?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data?.[0]?.whatsapp_template_dynamic_variable_id))
            if (actionVarConfig?.chatbot_custom_variable_configuration) {
                return actionVarConfig?.chatbot_custom_variable_configuration?.chatbot_custom_variable_fallback_value
            } else if (actionVarConfig?.fallback_value) {
                return actionVarConfig.fallback_value
            } else {
                // @ts-ignore
                return card?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data?.[0]?.whatsapp_template_dynamic_variable_sample_value || defaultWATemplateImg
            }
        }
    } 

    const getSubButtonText = (subBtnData: any) => {
        let fieldVal = subBtnData?.whatsapp_template_button_sub_type_field_data?.filter((field: any) => field.field_name == "Button Text")[0]
        return fieldVal?.whatsapp_template_button_sub_type_field_value
    }

    return (
        <> 
            {templateDetails && 
                <Grid item className={`${flagNodePreview ? carouselStyles.previewSectionCardBlock : styles.sectionCard} ${styles.carouselTemplatePreviewInNodeMainGrid}`}>
                        {flagNodePreview &&
                            <>
                                {renderTemplateDetailsGridInNode(templateDetails, currentActiveStaticWorkflow)}
                            </>
                        }
                    <Grid container className={(!flagNodePreview && !isScreenBelow1200) ? styles.previewCarouselTemplateMainSectionContent : ''}>
                        <Grid item xs={9.5} className={styles.carouselTemplatePrviewHeadItem}>
                            <pre
                                className={styles.preTextStyle}
                                dangerouslySetInnerHTML={{ __html: messageText("header") }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <div className={`${carouselStyles.slider_container} ${styles.carouselTemplatePreviewInNodeSlider}`}>
                                <Slider
                                    swipe={isScreenBelow1200 ? true : false}
                                    arrows={true}
                                    dots={false}
                                    infinite={false}
                                    autoplay={false}
                                    variableWidth={true}
                                    className={carouselStyles.chatbot_click_slider_template}
                                    slidesToShow={1}
                                    slidesToScroll={1}
                                    nextArrow={<SampleNextArrow className={carouselStyles.chat_slider_next_arrow} />}
                                    prevArrow={<SamplePrevArrow className={carouselStyles.chat_slider_prev_arrow} />}
                                // speed={400}
                                >
                                    {templateDetails?.whatsapp_template_data?.map((cards: any) => {
                                        return (
                                            <Grid item padding={cards?.whatsapp_template_header?.whatsapp_template_header_data && cards?.whatsapp_template_header.whatsapp_template_header_data.length > 0 && cards?.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_data_value ? "0px" : "0px"} className={styles.previewSectionCardBlock}>
                                                <Grid container direction={"column"} flexWrap={"nowrap"}>
                                                    <TemplatePreviewGlobal
                                                        headerType={cards?.whatsapp_template_header?.whatsapp_template_header_type_name || ""}
                                                        headerURL={getHeaderImage(cards)}
                                                        headerVaraibleData={cards?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data ?? []}
                                                        isFooter={cards?.whatsapp_template_footer && cards?.whatsapp_template_footer?.whatsapp_template_footer_value && cards?.whatsapp_template_footer?.whatsapp_template_footer_value?.length > 0}
                                                        headerText={messageText("header", cards)}
                                                        bodyText={messageText("body", cards)}
                                                        footerText={messageText("footer", cards)}
                                                    />

                                                    {
                                                        cards?.whatsapp_template_button && cards?.whatsapp_template_button.length > 0 && cards?.whatsapp_template_button.map((btnData: any, ind: number) => {
                                                            return <React.Fragment key={ind}>
                                                                {btnData?.whatsapp_template_button_data?.map((subBtnData: any, index: any) => {
                                                                    return <Grid item key={index} paddingBlock={"12px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                                                                        <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                                                                            <Grid item>
                                                                                {subButtonTypeIconMap[subBtnData?.whatsapp_template_button_sub_type_name?.toLowerCase() as keyof typeof subButtonTypeIconMap]}
                                                                            </Grid>
                                                                            <Grid item>
                                                                                {getSubButtonText(subBtnData)}
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                })}
                                                            </React.Fragment>
                                                        })
                                                    }
                                                </Grid>
                                            </Grid>
                                        );
                                    })} 
                                </Slider>
                            </div>
                        </Grid>
                    </Grid>
                </Grid> 
            }
        </>
    )
}

export default WorkflowCarouselTemplatePreview
